"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Section = exports.Root = exports.Dialog = exports.Buttons = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(4)
}));
const Buttons = exports.Buttons = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3)
}));
const Section = exports.Section = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1)
}));
const Dialog = exports.Dialog = (0, _mui.styled)(_components.Dialog)({
  cursor: 'auto'
});
